module.exports = __webpack_public_path__ + "static/media/Live-box.55da02ed.webp";